import angular from 'angular';
import infoConfirmBanner from './infoConfirmBanner';

export default angular
  .module('components.infoConfirmBanner', [])
  .component('infoConfirmBanner', infoConfirmBanner).name;
